export const createFadeIn = (mounted) => (delay = 0) => ({
  opacity: mounted ? 1 : 0,
  transform: mounted ? 'translateY(0)' : 'translateY(28px)',
  transition: `opacity 0.9s var(--ease-out) ${delay}s, transform 0.9s var(--ease-out) ${delay}s`,
});
